<template>
  <div class="board-root">
    <el-form size="mini" :inline="true" label-position="top" :model="searchForm" class="search-form">
      <el-form-item label="视图">
        <el-radio-group v-model="viewType" fill="#ec1c1c" @change="getInfo({itemPage:1})">
          <el-radio-button :label="1">按日</el-radio-button>
          <el-radio-button :label="2">按月</el-radio-button>
          <el-radio-button :label="3">按年</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开始日期">
        <el-date-picker
          v-model="searchForm.startDate"
          type="date"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期">
        <el-date-picker
          v-model="searchForm.endDate"
          type="date"
          placeholder="选择日期"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <span slot="label" style="color: transparent;">占位</span>
        <el-button type="primary" @click="getInfo({itemPage:1})">筛选</el-button>
      </el-form-item>
      <el-form-item>
        <span slot="label" style="color: transparent;">占位</span>
        <el-button @click="rest">清空</el-button>
      </el-form-item>
      <br />
      <el-form-item v-for="(item,i) of dateTypeOptions" :key="i">
        <span slot="label" :style="{color: item.key === 1 ? '' : 'transparent'}">{{i < 1 ? '快捷时间段' : '占位'}}</span>
        <el-button round @click="timeHand(item)">{{ item.label }}</el-button>
      </el-form-item>
    </el-form>
    <!-- 表格 -->
    <p class="table-title">{{
      `使用记录（${viewType === 1 ? '按日 · 明细' : (viewType === 2 ? '按月 · 汇总' : '按年 · 汇总')}）`
    }}<span v-show="viewType === 1">用量合计：<span style="color: #ec1c1c;">{{AallUsage}}</span> 次</span></p>
    <el-table v-loading="recordTableLoading" height="330" :data="recordData" border stripe class="table-sty">
      <el-table-column
        :prop="viewType === 1 ? 'day' : (viewType === 2 ? 'month' : 'year')" 
        :label="viewType === 1 ? '日期' : (viewType === 2 ? '月份' : '年份')"
      ></el-table-column>
      <el-table-column prop="assetName" label="套餐项"></el-table-column>
      <el-table-column prop="cnt" label="用量"></el-table-column>
      <el-table-column label="单位">次</el-table-column>
      <no-data text="暂无数据" slot="empty" />
    </el-table>
    <el-row class="pagination-sty">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[5, 10, 20, 50,100]"
        :total="pagenation.total"
        :current-page="pagenation.itemPage"
        :page-size="pagenation.pageSize"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-row>
  </div>
</template>
<script>
import moment from 'moment'
  import {ApiMethods} from '@/assets/js/http-serve/http-methods'
  export default {
    props:{
      isCurr:{type:Boolean,default:false},
      row:{type:Object,default:{}}
    },
    data () {
      // 这里存放数据
      return {
        pickerOptions: {
          disabledDate(time) {
            // 返回 true 表示该日期被禁用
            // time.getTime() > Date.now() 表示：如果日期时间大于现在，就禁用
            return time.getTime() > Date.now();
          }
        },
        AallUsage:0, // 用量合计
        viewType:1, // 视图类型, 默认按日
        pagenation:{
          itemPage:1,
          pageSize:5,
          total:0,
        },
        recordTableLoading:false,
        recordData:[],
        searchForm:{
          startDate:'',
          endDate:'',
        }, // 筛选表单
        dateTypeOptions:[
          // 1:7天,2:30天,3:90天,4:本月,5:本季度,6:本年
          {label:'最近7天',key:1},
          {label:'最近30天',key:2},
          {label:'本月',key:4},
          {label:'本季度',key:5},
          {label:'本年',key:6},
          {label:'全部',key:-1},
        ]
      }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {
      isCurr(val){
        if(val){
          this.getInfo();
        }
      }
    },
    // 方法集合
    methods: {
      rest(){
        this.searchForm.startDate=''
        this.searchForm.endDate=''
        this.pagenation.itemPage= 1
        this.searchForm.pageSize= 5
        this.viewType = 1
        this.getInfo();
      },
      /** 判断视图获取数据 */
      getInfo({dateType,itemPage:page}={}){
        const {assetItem:assetItemId} = this.row,{itemPage,pageSize} = this.pagenation,_this = this;
        let API = 'dailyUsage';
        switch (this.viewType) {
          case 2: // 按月视图接口
            API='monthlyUsage'
            break;
          case 3: // 按年视图接口
            API='annualUsage'
            break;
          default: // 按日视图接口
            API='dailyUsage';
            this.totalUsage();
            break;
        }
        _this.recordTableLoading = true;
        const param ={
          assetItemId,
          itemPage,
          pageSize,
          ...this.searchForm
        }
        if(dateType) {param.dateType = dateType};
        if(page) {
          param.itemPage = page;
          this.pagenation.itemPage = page
        };
        ApiMethods.accountCenter[API](param).then(res=>{
          if(!res.success) { return _this.$message.error(res.description) }
          _this.recordData = res.data;
          _this.pagenation.total = res.total
        }).finally(()=>{
          _this.recordTableLoading = false
        })
      },
      /** 查询套餐项总用量 */
      totalUsage(){
        const {itemPage,pageSize} = this.pagenation
        ApiMethods.accountCenter.totalUsage({
          ...this.searchForm,
          itemPage,pageSize,
          assetItemId:this.row.assetItem
        }).then(res=>{
          // if(!res.success) {return this.$message.error(res.description)}
          this.AallUsage = res.data || '--';
        })
      },
      // 时间响应式
      timeHand(item){
        const {key} = item,MAT='YYYY-MM-DD',todayEnd = moment().endOf('day');
        let bengin = '',end = '';
        switch (key) {
          case 1: // 最近7天
            // 开始日期：7天前的开始（00:00:00）
            bengin = moment().subtract(6, 'days').startOf('day').format(MAT)
            // 结束日期：今天结束（23:59:59）
            end = moment().endOf('day').format(MAT);
            this.viewType = 1;
            break;
          case 2: // 最近30天
            bengin = moment().subtract(29, 'days').startOf('day').format(MAT)
            end = moment().endOf('day').format(MAT);
            this.viewType = 1;
            break;
          case 4: // 本月
            bengin = moment().startOf('month').format(MAT)
            end = moment.min(moment().endOf('month'), todayEnd).format(MAT);
            this.viewType = 1;
            break;
          case 5: // 本季度
            bengin = moment().startOf('quarter').format(MAT)
            end = moment.min(moment().endOf('quarter'), todayEnd).format(MAT)
            this.viewType = 2;
            break;
          case 6: // 本年
            bengin = moment().startOf('year').format(MAT)
            end =  moment.min(moment().endOf('year'), todayEnd).format(MAT)
            this.viewType = 2;
            break;
          case -1: // 全部
            bengin = ''
            end = ''
            this.viewType = 3;
            break;
          default: // 当天
            bengin = moment().startOf('day').format(MAT)
            end = moment().endOf('day').format(MAT)
            break;
        }
        this.searchForm.startDate = bengin;
        this.searchForm.endDate = end;
        this.getInfo({dateType:key,itemPage:1})
      },
      /** 分页 */
      handleSizeChange(pageSize){
        this.pagenation.pageSize = pageSize;
        this.pagenation.itemPage = 1;
        this.getInfo();
      },
      handleCurrentChange(pageNum){
        this.pagenation.itemPage = pageNum;
        this.getInfo();
      },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {},
  }
</script>
<style lang='less' scoped>
  // @import url(); 引入公共css类
  .board-root{
    height: 580px;
    padding: 10px 20px;
    .search-form{
      padding: 5px 10px;
      box-shadow: 0 0 5px 0 #ccc;
      border-radius: 10px;
      .date-item{
        /deep/ .el-form-item__content{
          width: 132px;
          .el-date-editor.el-input, .el-date-editor.el-input__inner{
            width: 100%;
          }
        }
      }
    }
    .table-title{
      font-weight: bold;
      padding: 5px 0;
      display: flex;
      justify-content: space-between;
    }
    .table-sty{
      margin-bottom: 20px;
    }
    .pagination-sty{
      text-align: right;
    }
  }
  /deep/ .el-form--label-top .el-form-item__label{
    padding: 0;
  }
  /deep/.el-table--scrollable-y .el-table__body-wrapper {
  scrollbar-width: thin;
  /* firefox */
  -ms-overflow-style: auto;
  /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}

/deep/.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: block;
  /* Chrome Safari */
}
</style>


// WEBPACK FOOTER //
// pages/tpl/components/accounRecord/recordBoard.vue